/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_MeetingsInputs */



/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Settings_Tab_MeetingsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_tab_meetings = /** @type {((inputs?: Settings_Tab_MeetingsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_MeetingsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversations")
	return /** @type {LocalizedString} */ ("Conversations")
});